import React from "react";
import { Field, FieldArray } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripLines } from "@fortawesome/pro-regular-svg-icons/faGripLines";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import Sortable from "react-sortablejs";
import { Input, RichText, File, SortableRow } from "@peracto/peracto-ui";
import last from "lodash/last";

const FORMATTED_TITLES = {
    product_features: "Product Features",
};

export const ProductFeaturesRow = ({ group, groupLabel, disabled }) => {
    return (
        <Field name={`productResources.${group}`}>
            {({ field, form }) => (
                <>
                    <FieldArray name={field.name}>
                        {({ move, push, remove }) => (
                            <>
                                <div className="form-group">
                                    <label className="mb-1 capitalize">
                                        {groupLabel}
                                    </label>
                                    {field?.value?.length > 0 && (
                                        <table className="table table-sm mb-1 table-fixed">
                                            <colgroup>
                                                <col width="5%" />
                                                <col width="10%" />
                                                <col width="70%" />
                                                <col width="15%" />
                                            </colgroup>

                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th className="text-right">
                                                        Remove
                                                    </th>
                                                </tr>
                                            </thead>

                                            <Sortable
                                                tag="tbody"
                                                onChange={(
                                                    order,
                                                    sortable,
                                                    evt,
                                                ) => {
                                                    if (!disabled) {
                                                        move(
                                                            evt.oldIndex,
                                                            evt.newIndex,
                                                        );
                                                    }
                                                }}
                                                options={{
                                                    animation: 100,
                                                    handle: ".handle",
                                                }}
                                            >
                                                {field.value.map(
                                                    (item, index) => (
                                                        <SortableRow
                                                            key={index}
                                                            data-id={index}
                                                            data-testid={`${group}s__item`}
                                                        >
                                                            <td>
                                                                <span
                                                                    className="handle"
                                                                    data-testid={`${group}_item_${index}_slider-handle`}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faGripLines
                                                                        }
                                                                    />
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <img
                                                                    src={
                                                                        item.location
                                                                    }
                                                                    style={{
                                                                        width: "100%",
                                                                    }}
                                                                    title={
                                                                        item.location
                                                                    }
                                                                    data-testid={`${group}_item_${index}_image`}
                                                                    alt="Product Feature"
                                                                />
                                                            </td>

                                                            <td>
                                                                <div className="flex flex-col gap-y-[15px]">
                                                                    <Input
                                                                        name={`productResources.${group}.${index}.title`}
                                                                        label="Title"
                                                                        placeholder="Title"
                                                                        testId={`${group}_item_${index}_title`}
                                                                        disabled={
                                                                            disabled
                                                                        }
                                                                    />

                                                                    <RichText
                                                                        name={`productResources.${group}.${index}.description`}
                                                                        label="Content"
                                                                        placeholder="Content"
                                                                        testId={`${group}_item_${index}_description`}
                                                                        disabled={
                                                                            disabled
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>

                                                            <td className="text-right">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => {
                                                                        if (
                                                                            !disabled
                                                                        ) {
                                                                            remove(
                                                                                index,
                                                                                1,
                                                                            );
                                                                        }
                                                                    }}
                                                                    disabled={
                                                                        disabled
                                                                    }
                                                                    data-testid={`${group}_item_${index}_remove`}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faTrash
                                                                        }
                                                                    />
                                                                </button>
                                                            </td>
                                                        </SortableRow>
                                                    ),
                                                )}
                                            </Sortable>
                                        </table>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <File
                                                testId={`${group}s__input`}
                                                name={`resources_${groupLabel}`}
                                                disabled={disabled}
                                                placeholder={`Add a new ${
                                                    FORMATTED_TITLES[
                                                        groupLabel
                                                    ] ||
                                                    groupLabel.toLowerCase()
                                                } to the product`}
                                                onKeyPress={(e) => {
                                                    if (e.key === "Enter") {
                                                        e.preventDefault();

                                                        if (
                                                            e.target.value
                                                                .length > 0
                                                        ) {
                                                            const filename =
                                                                last(
                                                                    e.target.value.split(
                                                                        "/",
                                                                    ),
                                                                );

                                                            push({
                                                                location:
                                                                    e.target
                                                                        .value,
                                                                title: decodeURI(
                                                                    filename,
                                                                ),
                                                                description: "",
                                                            });

                                                            e.target.value = "";
                                                        }
                                                    }
                                                }}
                                                onSelectCallback={(value) => {
                                                    if (value.length > 0) {
                                                        const filename = last(
                                                            value.split("/"),
                                                        );
                                                        push({
                                                            location: value,
                                                            title: decodeURI(
                                                                filename,
                                                            ),
                                                            description: "",
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </FieldArray>
                </>
            )}
        </Field>
    );
};
